import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  /* 首页部分路由，不需要登陆也可以查看*/
  {
    path: '/',
    redirect: '/index/gamePage/bxzl'
  },
  {
    path: '/index/gamePage/bxzl',
    component: () => import('@/views/gamePage/bxzl')
  },
  {
    path: '/index/about',
    component: () => import('@/views/index/about')
  },
  {
    path: '/index/recruit',
    component: () => import('@/views/index/recruit')
  },
  {
    path: '/index/news',
    component: () => import('@/views/index/news')
  },
  {
    path: '/index/newInfo',
    component: () => import('@/views/index/news/newInfo')
  },
  {
    path: '/index/404',
    component: () => import('@/views/404.vue'),
    hidden: true
  },
  /* 因为匹配符是 * 所以必须在最后*/
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// 配置文档，vue路由官方github: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
